import React from "react";
import {
    StyleProp,
    StyleSheet,
    TextProps,
    TextStyle,
    TouchableOpacity,
    ViewStyle,
} from "react-native";
import Text from "./Text";
import { useTheme } from "../hooks/use-theme";

type FormattedTextProps = {
    children?: React.ReactNode;
    color?: string;
    style?: TextStyle;
    numberOfLines?: number | undefined;
} & TextProps;

type LinkTextProps = {
    children?: React.ReactNode;
    onPress: () => void;
    style?: StyleProp<ViewStyle>;
};

export const TitleLargeText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.titleLargeText, style]}
            {...props}
        />
    );
};

export const TitleMediumText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.titleMediumText, style]}
            {...props}
        />
    );
};

export const TitleSmallText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.titleSmallText, style]}
            {...props}
        />
    );
};

export const BodyLargeText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.bodyLargeText, style]}
            {...props}
        />
    );
};

export const BodyMediumText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.bodyMediumText, style]}
            {...props}
        />
    );
};

export const BodySmallText: React.FC<FormattedTextProps> = ({
    color,
    style,
    numberOfLines,
    ...props
}) => {
    const styles = useStyles();
    return (
        <Text
            numberOfLines={numberOfLines}
            style={[{ color }, styles.bodySmallText, style]}
            {...props}
        />
    );
};

export const LinkMediumText: React.FC<LinkTextProps> = ({ children, onPress }) => {
    const styles = useStyles();
    return (
        <TouchableOpacity onPress={onPress}>
            <Text style={styles.linkMedium}>{children}</Text>
        </TouchableOpacity>
    );
};

export const LinkSmallText: React.FC<LinkTextProps> = ({ children, onPress }) => {
    const styles = useStyles();
    return (
        <TouchableOpacity onPress={onPress}>
            <Text style={styles.linkSmall}>{children}</Text>
        </TouchableOpacity>
    );
};

export const LinkSmallTextBold: React.FC<LinkTextProps> = ({ children, onPress, style }) => {
    const styles = useStyles();
    return (
        <TouchableOpacity onPress={onPress} style={style}>
            <Text style={styles.linkSmallBold}>{children}</Text>
        </TouchableOpacity>
    );
};

const useStyles = () => {
    const { colors, fonts } = useTheme();
    return StyleSheet.create({
        bodyMediumText: {
            ...fonts.bodyMedium,
        },
        bodyLargeText: {
            ...fonts.bodyLarge,
        },
        bodySmallText: {
            ...fonts.bodySmall,
        },
        linkMedium: {
            ...fonts.bodyMedium,
            color: colors.secondary,
        },
        titleLargeText: {
            ...fonts.titleLarge,
        },
        titleMediumText: {
            ...fonts.titleMedium,
        },
        titleSmallText: {
            ...fonts.titleSmall,
        },
        linkSmall: {
            ...fonts.bodySmall,
            color: colors.secondary,
        },
        linkSmallBold: {
            ...fonts.labelSmall,
            color: colors.secondary,
            fontWeight: "bold",
        },
    });
};
